// import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { Applicazione, apps, AppType } from "../models/applicazione";
import { merge } from "lodash";
import { Principal } from "../models/principal";
import { ApplicazioniValue } from "../utils/costanti";

export const getApplicazioni = (ip: string, authData: AuthDataType, user: User, identity: Principal) => {
    
    // return fetch(`${this.endpoint}/applicazioni`, this.createJsonFetchOptions('GET'))
    //     .then<Applicazione[]>(this.asJson);

    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    // console.log('Get Agencies body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/applicazione`
    console.log('Get Applicazioni', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
        // body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getApplicazioni ("${authData.user}") -> letti ${json.length} applicaziones`);
            //List sono le app configurate come diritti su Piero
            const list = json as Applicazione[];
            console.log('getApplicazioni recuperato list da DB: ' + JSON.stringify(list));
            let items: Applicazione[] = [];
            //Apps sono tutte le app mappate nelle costanti
            console.log('apps da costanti: ' + JSON.stringify(apps)); 
            apps.map(app => {
                let item = merge(new Applicazione(), app);
                item.inactive = list.find(x => x.Guid === app.Guid) === undefined;
                if (item.Type === AppType.IFORFETTARI && identity && identity.ApplicationForfetari === true) 
                    item.inactive = false;
                else if (item.Type === AppType.CONVSRL && identity && identity.ApplicationConvenienza === true)
                    item.inactive = false;
                else if (item.Type === AppType.BUDGET4U && identity && identity.ApplicationBudget === true)
                    item.inactive = false;
                else if (item.Type === AppType.EASYSTART && identity /*&& !identity.ApplicationEasyStart*/)
                {
                    console.log('Sono in Easy Start')
                    // Easy start dipende da Piero, non dalla applicazione consultool
                    const guid = list.find(x => x.Guid === ApplicazioniValue.EasyStart);
                    console.log('Sono in Easy Start guid: ' + JSON.stringify(guid))
                    if (!guid) {
                        item.inactive = true;
                    } else {
                        item.inactive = false;
                    }
                }
                items.push(item);
            })
            // console.log('getApplicazioni item creati: ' + JSON.stringify(items));
            return items;
        })
        .catch(error => {
            console.log('getApplicazioni error:', error);
            throw error;
        });
}
